import { render, staticRenderFns } from "./TimeSpentRatios.vue?vue&type=template&id=18d05224&scoped=true&"
import script from "./TimeSpentRatios.vue?vue&type=script&lang=js&"
export * from "./TimeSpentRatios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d05224",
  null
  
)

export default component.exports